import { Heading, VStack } from '@chakra-ui/react';

interface StepTitleProps {
  stepNumber: number;
  title: string;
}

export const StepTitle: React.FC<StepTitleProps> = ({ stepNumber, title }) => {
  return (
    <VStack gap={0} textAlign="center" w="full">
      <Heading
        fontSize={{ base: 'lg', md: 'xl' }}
        fontWeight="bold"
        color="green.500"
        textTransform="uppercase"
      >
        Step {stepNumber}.
      </Heading>
      <Heading
        fontSize={{ base: 'xl', md: '2xl' }}
        fontWeight="bold"
        color="green.500"
        lineHeight="1.2"
      >
        {title}
      </Heading>
    </VStack>
  );
};
